import { useFieldHelper, LinkField } from 'framework/ui/field';
import { useProcessInstanceId, useProcessInstanceUrl } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import React from 'react';

const VariablesLinkField = ({ source, bpmnJs, ...props }: any) => {
  const { getValue: getExecutionId } = useFieldHelper({ source });

  const { getVariablesUrl } = useProcessInstanceUrl();
  const processId = useProcessInstanceId();
  const variableContext = getExecutionId();
  const url = getVariablesUrl(processId, variableContext);

  return <LinkField {...props} linkText="Variables" value={url} isInternal />;
};

export default VariablesLinkField;
